import { render, staticRenderFns } from "./updateEnCertifiedModal.vue?vue&type=template&id=3dd81234&scoped=true&"
import script from "./updateEnCertifiedModal.vue?vue&type=script&lang=js&"
export * from "./updateEnCertifiedModal.vue?vue&type=script&lang=js&"
import style0 from "./updateEnCertifiedModal.vue?vue&type=style&index=0&id=3dd81234&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd81234",
  null
  
)

export default component.exports